import { render, staticRenderFns } from "./MessageSendWithAttachmentView.vue?vue&type=template&id=500f2536&scoped=true&"
import script from "./MessageSendWithAttachmentView.vue?vue&type=script&lang=ts&"
export * from "./MessageSendWithAttachmentView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSendWithAttachmentView.vue?vue&type=style&index=0&id=500f2536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f2536",
  null
  
)

export default component.exports